import PropTypes from 'prop-types';
import React from 'react';

import Pager from 'common/components/Pager';
import ResultCount from 'common/components/ResultCount';

import './pager-group.scss';

const PagerGroup = ({ currentPage, onChangePage, resultCount, resultsPerPage }) => (
  <div className="pager-group">
    <Pager
      changePage={onChangePage}
      currentPage={currentPage}
      resultCount={resultCount}
      resultsPerPage={resultsPerPage}
    />
    <ResultCount pageNumber={currentPage} resultsPerPage={resultsPerPage} total={resultCount} />
  </div>
);

PagerGroup.propTypes = {
  currentPage: PropTypes.number,
  onChangePage: PropTypes.func,
  resultCount: PropTypes.number,
  resultsPerPage: PropTypes.number,
};

export default PagerGroup;
